export function configureConsole() {
  const env = process.env.REACT_APP_ENVIRONMENT;

  if (env !== "Development") {
    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
    console.info = () => {};
    console.debug = () => {};
  }
}
